import * as Yup from "yup";

const validationSchema = Yup.object().shape({
    language: Yup.object().required("اللغة مطلوبة"),
    level: Yup.object().required("المستوى مطلوب"),
});

export default validationSchema;
